import PropTypes from "prop-types";
import React from "react";
import ProductFull from "@brand/Product/default/ProductFull";
import { productShape } from "app/utils/propTypes";
import "./product-full-list.scss";

class ProductFullList extends React.PureComponent {
	render() {
		const { products = [] } = this.props;

		const productsNodes = products.map((product, index) => {
			return (
				<div key={product.id} className="product-full-list__item">
					<ProductFull product={product} position={index} />
				</div>
			);
		});

		return <div className="product-full-list">{productsNodes}</div>;
	}
}

ProductFullList.propTypes = {
	products: PropTypes.arrayOf(productShape),
};

export default ProductFullList;
